export default (params, translator = value => value, storeName = null, username = null) => {
  const crumbs = [];

  if (params.parentId) {
    crumbs.push({
      path: `/reports/${params.collectionType}/${params.parentId}`,
      name: translator('Worldwide')
    });
  }

  if (params.region) {
    crumbs.push({
      path: `/reports/${params.collectionType}/${params.parentId}/${params.region}`,
      name: translator(params.region)
    });
  }

  if (params.country) {
    crumbs.push({
      path: `/reports/${params.collectionType}/${params.parentId}/${params.region}/${params.country}`,
      name: params.country
    });
  }

  if (params.store) {
    crumbs.push({
      path: `/reports/${params.collectionType}/${params.parentId}/${params.region}/${params.country}/${params.store}`,
      name: storeName
    });
  }

  if (params.username) {
    crumbs.push({
      path: `/reports/${params.collectionType}/${params.parentId}/${params.region}/${params.country}/${params.store}/${params.username}`,
      name: username
    });
  }

  return crumbs;
}
